import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const TEMPO_OCULTAR_MS = 2000;
const ALTURA_MINIMA_THUMB = 40;
const MARGEM_TRILHO = 4;

export function useScrollbarFlutuante() {
    const visivel = ref(false);
    const arrastando = ref(false);
    const alturaThumb = ref(0);
    const topoThumb = ref(0);
    const temScroll = ref(false);

    let timerOcultar = null;
    let inicioArrasteY = 0;
    let inicioArrasteScroll = 0;
    let frame = null;

    const estiloThumb = computed(() => ({
        height: `${alturaThumb.value}px`,
        transform: `translateY(${topoThumb.value}px)`,
    }));

    function alturaTrilho() {
        return window.innerHeight - MARGEM_TRILHO * 2;
    }

    function atualizarThumb() {
        const doc = document.documentElement;
        const alturaTotal = doc.scrollHeight;
        const alturaVisivel = window.innerHeight;
        const trilho = alturaTrilho();

        temScroll.value = alturaTotal > alturaVisivel + 1;
        if (!temScroll.value) return;

        const altura = Math.max((alturaVisivel / alturaTotal) * trilho, ALTURA_MINIMA_THUMB);
        const scrollMaximo = alturaTotal - alturaVisivel;
        const progresso = scrollMaximo > 0 ? window.scrollY / scrollMaximo : 0;

        alturaThumb.value = altura;
        topoThumb.value = MARGEM_TRILHO + progresso * (trilho - altura);
    }

    function agendarAtualizacao() {
        if (frame) return;
        frame = requestAnimationFrame(() => {
            frame = null;
            atualizarThumb();
        });
    }

    function agendarOcultar() {
        clearTimeout(timerOcultar);
        timerOcultar = setTimeout(() => {
            if (!arrastando.value) visivel.value = false;
        }, TEMPO_OCULTAR_MS);
    }

    function mostrar() {
        agendarAtualizacao();
        visivel.value = true;
        agendarOcultar();
    }

    function iniciarArraste(evento) {
        evento.preventDefault();
        arrastando.value = true;
        inicioArrasteY = evento.clientY;
        inicioArrasteScroll = window.scrollY;
        clearTimeout(timerOcultar);
        document.addEventListener('pointermove', moverArraste);
        document.addEventListener('pointerup', finalizarArraste);
    }

    function moverArraste(evento) {
        const doc = document.documentElement;
        const espacoLivre = alturaTrilho() - alturaThumb.value;
        if (espacoLivre <= 0) return;

        const scrollMaximo = doc.scrollHeight - window.innerHeight;
        const deslocamento = evento.clientY - inicioArrasteY;
        window.scrollTo({ top: inicioArrasteScroll + (deslocamento / espacoLivre) * scrollMaximo });
    }

    function finalizarArraste() {
        arrastando.value = false;
        document.removeEventListener('pointermove', moverArraste);
        document.removeEventListener('pointerup', finalizarArraste);
        agendarOcultar();
    }

    onMounted(() => {
        atualizarThumb();
        window.addEventListener('scroll', mostrar, { passive: true });
        window.addEventListener('resize', agendarAtualizacao);
    });

    onBeforeUnmount(() => {
        clearTimeout(timerOcultar);
        cancelAnimationFrame(frame);
        window.removeEventListener('scroll', mostrar);
        window.removeEventListener('resize', agendarAtualizacao);
        finalizarArraste();
    });

    return { visivel, arrastando, temScroll, estiloThumb, mostrar, iniciarArraste };
}
